
import Vue from 'vue'
import XTable from 'vux/src/components/x-table/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


var CostPage = Vue.extend({})
Vue.component('cost-page', CostPage)

export default {
  name: 'CostPage',
  components: {
    XTable, XButton
  },
  props: {
    idArr: Array
  },
  data () {
    return {
      baseUrl: this.$store.state.url,
      info: {},
      picArr1: [], // 造价文件
      picArr2: [], // 工时汇总
      picArr3: []// 委托单位信息
    }
  },
  mounted () {
    this.axios({
      url: this.baseUrl + '/wechat/todo/businessDetail/' + this.idArr[0] + '/' + this.idArr[1] + '/' + this.idArr[2],
      method: 'get'
    }).then((response) => {
      this.info = response.data.data.info
    }).catch((response) => {
    })
  },
  methods: {
    getImg (imgType) {
      // if(imgType == 'worktree' && this.picArr1.length>0){//造价文件
      //   this.showImg(1);
      // }else if(imgType == 'worktime' && this.picArr2.length>0){//工时汇总
      //   this.showImg(2);
      // }else if(imgType == 'showUnitPage_1' && this.picArr3.length>0){//委托单位信息
      //   this.showImg(3);
      // }else{
      this.$vux.loading.show({
        text: '加载中'
      })
      this.picArr1 = []
      this.picArr2 = []
      this.picArr3 = []
      this.axios({
        url: this.baseUrl + '/wechat/commonFile/screenPage?taskId=' + this.idArr[0] + '&flowId=' + this.idArr[1] + '&stepId=' + this.idArr[2] + '&type=' + imgType,
        method: 'get'
      }).then((response) => {
        this.$vux.loading.hide()
        if (response.data.status == false) { // 返回失败
          this.showErr()
        } else { // 返回成功
          debugger
          if (imgType == 'showUnitPage_1') { // 委托单位信息
            let urlArr = response.data.imageUrl.split(',')
            for (let i = 0; i < urlArr.length; i++) {
              if (urlArr[i] != '') {
                this.picArr3.push(urlArr[i] + '?number=' + Math.random())
              }
            }
            if (this.picArr3.length > 0) {
              this.showImg(3)
            } else {
              this.showErr()
            }
          } else if (imgType == 'worktree') { // 造价文件
            let urlArr = response.data.imageUrl.split(',')
            for (let i = 0; i < urlArr.length; i++) {
              if (urlArr[i] != '') {
                this.picArr1.push(urlArr[i] + '?number=' + Math.random())
              }
            }
            if (this.picArr1.length > 0) {
              this.showImg(1)
            } else {
              this.showErr()
            }
          } else if (imgType == 'worktime') { // 工时汇总
            let urlArr = response.data.imageUrl.split(',')
            for (let i = 0; i < urlArr.length; i++) {
              if (urlArr[i] != '') {
                this.picArr2.push(urlArr[i] + '?number=' + Math.random())
              }
            }
            if (this.picArr2.length > 0) {
              this.showImg(2)
            } else {
              this.showErr()
            }
          }
        }
      }).catch((response) => {
        this.$vux.loading.hide()
        this.showErr()
      })
      // }
    },
    showImg (num) {
      let arrOnShow
      if (num == 1) {
        arrOnShow = this.picArr1
      } else if (num == 2) {
        arrOnShow = this.picArr2
      } else if (num == 3) {
        arrOnShow = this.picArr3
      }
      wx.previewImage({
        current: arrOnShow[0],
        urls: arrOnShow
      })
    },
    showErr () {
      this.$vux.alert.show({
        title: '暂无数据'
      })
      setTimeout(() => {
        this.$vux.alert.hide()
      }, 2000)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/detail/todo/business/cost.vue